
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
// Sequential Section Animations
function $3f763f07b7f268f2$export$949d06beb7be649c() {
    const sections = document.querySelectorAll('.section');
    let currentSectionIndex = 0;
    // Hide all sections initially
    sections.forEach((section)=>{
        section.style.opacity = '0';
        section.style.transform = 'translateY(20px)';
        section.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
    });
    function animateNextSection() {
        if (currentSectionIndex >= sections.length) return;
        const currentSection = sections[currentSectionIndex];
        // Show section
        currentSection.style.opacity = '1';
        currentSection.style.transform = 'translateY(0)';
        // Special handling for header section
        if (currentSection.id === 'header') {
            // First show ASCII art
            const asciiArt = currentSection.querySelector('.ascii-art');
            if (asciiArt) {
                asciiArt.style.opacity = '1';
                asciiArt.style.transform = 'translateY(0)';
            }
            // Then handle info-block with its own prompt and content
            setTimeout(()=>{
                const infoBlock = currentSection.querySelector('.info-block');
                const prompt = infoBlock ? infoBlock.querySelector('.prompt') : null;
                const command = prompt ? prompt.querySelector('.command') : null;
                const content = infoBlock ? infoBlock.querySelector('.content') : null;
                // Show info-block container (but not its content yet)
                if (infoBlock) {
                    infoBlock.style.opacity = '1';
                    infoBlock.style.transform = 'translateY(0)';
                    // Make sure content is still hidden
                    if (content) {
                        content.style.opacity = '0';
                        content.style.transform = 'translateY(10px)';
                    }
                }
                // Animate command typing
                if (command && content) $3f763f07b7f268f2$export$d0b92fdea0aeaccd(command, ()=>{
                    setTimeout(()=>{
                        content.style.opacity = '1';
                        content.style.transform = 'translateY(0)';
                        // Move to next section
                        setTimeout(()=>{
                            currentSectionIndex++;
                            animateNextSection();
                        }, 800);
                    }, 300);
                });
            }, 600);
            return;
        }
        // Regular section handling
        const prompt = currentSection.querySelector('.prompt');
        const command = prompt ? prompt.querySelector('.command') : null;
        const content = currentSection.querySelector('.boot-sequence, .content, .ascii-art, .skills-grid, .experience-list, .projects-grid, .education-list, .achievements-grid, .contact-info');
        // Animate command typing if exists
        if (command) $3f763f07b7f268f2$export$d0b92fdea0aeaccd(command, ()=>{
            // After command is typed, show content
            if (content) setTimeout(()=>{
                content.style.opacity = '1';
                content.style.transform = 'translateY(0)';
                // Animate individual items within the section
                $3f763f07b7f268f2$export$650105bc80c6768(currentSection);
                // Move to next section after content is shown
                setTimeout(()=>{
                    currentSectionIndex++;
                    // Check if this is the last section
                    if (currentSectionIndex >= sections.length) // All sections are done, apply initial translations and initialize interactive command line
                    setTimeout(()=>{
                        // Apply translations if language is not Russian (default in HTML)
                        const { currentLanguage: currentLanguage, updateTranslations: updateTranslations } = window.translationsModule;
                        if (currentLanguage === 'en') updateTranslations();
                        window.commandLineModule.initInteractiveCommandLine();
                    }, 1000);
                    else animateNextSection();
                }, 1200);
            }, 300);
            else // No content, move to next section
            setTimeout(()=>{
                currentSectionIndex++;
                // Check if this is the last section
                if (currentSectionIndex >= sections.length) // All sections are done, apply initial translations and initialize interactive command line
                setTimeout(()=>{
                    // Apply translations if language is not Russian (default in HTML)
                    const { currentLanguage: currentLanguage, updateTranslations: updateTranslations } = window.translationsModule;
                    if (currentLanguage === 'en') updateTranslations();
                    window.commandLineModule.initInteractiveCommandLine();
                }, 1000);
                else animateNextSection();
            }, 1000);
        });
        else {
            // No command, just show content
            if (content) setTimeout(()=>{
                content.style.opacity = '1';
                content.style.transform = 'translateY(0)';
                // Animate individual items within the section
                $3f763f07b7f268f2$export$650105bc80c6768(currentSection);
            }, 200);
            setTimeout(()=>{
                currentSectionIndex++;
                // Check if this is the last section
                if (currentSectionIndex >= sections.length) // All sections are done, apply initial translations and initialize interactive command line
                setTimeout(()=>{
                    // Apply translations if language is not Russian (default in HTML)
                    const { currentLanguage: currentLanguage, updateTranslations: updateTranslations } = window.translationsModule;
                    if (currentLanguage === 'en') updateTranslations();
                    window.commandLineModule.initInteractiveCommandLine();
                }, 1000);
                else animateNextSection();
            }, 1400);
        }
    }
    // Hide all content initially
    sections.forEach((section)=>{
        const allContent = section.querySelectorAll('.boot-sequence, .content, .ascii-art, .info-block, .skills-grid, .experience-list, .projects-grid, .education-list, .achievements-grid, .contact-info');
        allContent.forEach((content)=>{
            content.style.opacity = '0';
            content.style.transform = 'translateY(10px)';
            content.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        });
    });
    // Start animation sequence
    setTimeout(()=>{
        animateNextSection();
    }, 1000);
}
function $3f763f07b7f268f2$export$d0b92fdea0aeaccd(commandElement, callback) {
    const text = commandElement.textContent;
    commandElement.textContent = '';
    commandElement.style.borderRight = '2px solid var(--neon-green)';
    let i = 0;
    const timer = setInterval(()=>{
        commandElement.textContent = text.slice(0, i);
        i++;
        if (i > text.length) {
            clearInterval(timer);
            commandElement.style.borderRight = 'none';
            if (callback) callback();
        }
    }, 80);
}
function $3f763f07b7f268f2$export$650105bc80c6768(section) {
    const items = section.querySelectorAll('.skill-item, .job, .project-card, .education-item, .achievement-item, .boot-sequence .line');
    items.forEach((item, index)=>{
        setTimeout(()=>{
            item.style.opacity = '1';
            item.style.transform = 'translateX(0)';
        }, index * 100);
    });
}
function $3f763f07b7f268f2$export$e01dc2784d396ab2() {
    const cursor = document.querySelector('.cursor');
    if (cursor) setInterval(()=>{
        cursor.style.opacity = cursor.style.opacity === '0' ? '1' : '0';
    }, 500);
}


var $35b6b3c7a0f265f7$exports = {};

$parcel$export($35b6b3c7a0f265f7$exports, "initInteractiveCommandLine", () => $35b6b3c7a0f265f7$export$62d44a696b25a76a);
var $5be814878a8c9e96$exports = {};

$parcel$export($5be814878a8c9e96$exports, "translations", () => $5be814878a8c9e96$export$150b732325d14d04);
$parcel$export($5be814878a8c9e96$exports, "currentLanguage", () => $5be814878a8c9e96$export$324a75438e87a537);
$parcel$export($5be814878a8c9e96$exports, "switchLanguage", () => $5be814878a8c9e96$export$fa43c961ec463ef0);
$parcel$export($5be814878a8c9e96$exports, "updateTranslations", () => $5be814878a8c9e96$export$676ff478edc2cd7f);
// Language switching functionality
const $5be814878a8c9e96$export$150b732325d14d04 = {
    en: {
        // Meta
        title: 'Nikita Karasyov | Frontend Developer',
        // Boot sequence
        bootLine1: '> Initializing portfolio system...',
        bootLine2: '> Loading developer profile...',
        bootLine3: '> Connecting to skills database...',
        bootLine4: '> [OK] System ready',
        bootLine5: "> Welcome to Nikita Karasyov's portfolio",
        // About section
        aboutAge: '> Frontend Developer | 4+ years experience',
        aboutBorn: '> Age: 22 | Born: January 29, 2003',
        aboutLocation: '> Location: All world',
        aboutStatus: '> Status: Available for new opportunities',
        aboutSpec: '> Specialization: React, Vue.js, TypeScript, Next.js',
        aboutQuote: '> "Create adaptive user interfaces with clean and scalable code"',
        // Experience
        jobLuminary: 'Frontend Developer',
        jobLuminaryDesc1: '> B2B web application development with React & TypeScript',
        jobLuminaryDesc2: '> Created and maintained component library',
        jobLuminaryDesc3: '> Performance optimization and code quality improvements',
        jobLuminaryDesc4: '> Cross-functional team collaboration',
        jobEasycode: 'Frontend Developer',
        jobEasycodeDesc1: '> Corporate HR system development',
        jobEasycodeDesc2: '> Interactive dashboards with Vue.js',
        jobEasycodeDesc3: '> Built responsive interfaces from Figma designs',
        jobEasycodeDesc4: '> Mentored junior developers and code reviews',
        jobBottec: 'Frontend Developer',
        jobBottecDesc1: '> Led development of 11 projects from scratch',
        jobBottecDesc2: '> Team leadership and project coordination',
        jobBottecDesc3: '> Full-stack development with modern technologies',
        jobBottecDesc4: '> 100% projects successfully delivered to production',
        // Education
        eduMfpu: 'Higher Education',
        eduMfpuDesc: '> Specialized in information technologies and business processes',
        eduHexlet: 'Frontend Development Course',
        eduHexletDesc1: '> Intensive web development program',
        eduHexletDesc2: '> JavaScript, React, modern development practices',
        eduSelf: 'Continuous Learning',
        eduSelfDesc1: '> Various online courses in web development',
        eduSelfDesc2: '> Cybersecurity and system administration',
        eduSelfDesc3: '> UX/UI Design and modern web technologies',
        // Achievements
        achProjects: 'Completed Projects',
        achProduction: 'Projects in Production',
        achTeam: 'Team Members Led',
        achExperience: 'Years Experience',
        // Contact
        email: '> email:',
        telegram: '> telegram:',
        github: '> github:',
        linkedin: '> linkedin:',
        phoneRu: '> phone_ru:',
        phoneVn: '> phone_vn:',
        privacy: '> privacy:',
        privacyText: 'privacy policy',
        // Commands
        langSwitch: 'lang --switch',
        langSwitchDesc: 'Switch language between English and Russian',
        contactDesc: 'Start contact'
    },
    ru: {
        // Meta
        title: "\u041D\u0438\u043A\u0438\u0442\u0430 \u041A\u0430\u0440\u0430\u0441\u0451\u0432 | Frontend \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A",
        // Boot sequence
        bootLine1: "> \u0418\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043F\u043E\u0440\u0442\u0444\u043E\u043B\u0438\u043E...",
        bootLine2: "> \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043F\u0440\u043E\u0444\u0438\u043B\u044F \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430...",
        bootLine3: "> \u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A \u0431\u0430\u0437\u0435 \u043D\u0430\u0432\u044B\u043A\u043E\u0432...",
        bootLine4: "> [\u041E\u041A] \u0421\u0438\u0441\u0442\u0435\u043C\u0430 \u0433\u043E\u0442\u043E\u0432\u0430",
        bootLine5: "> \u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C \u0432 \u043F\u043E\u0440\u0442\u0444\u043E\u043B\u0438\u043E \u041D\u0438\u043A\u0438\u0442\u044B \u041A\u0430\u0440\u0430\u0441\u0451\u0432\u0430",
        // About section
        aboutAge: "> Frontend \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A | 4+ \u0433\u043E\u0434\u0430 \u043E\u043F\u044B\u0442\u0430",
        aboutBorn: "> \u0412\u043E\u0437\u0440\u0430\u0441\u0442: 22 | \u0420\u043E\u0434\u0438\u043B\u0441\u044F: 29 \u044F\u043D\u0432\u0430\u0440\u044F 2003",
        aboutLocation: "> \u041B\u043E\u043A\u0430\u0446\u0438\u044F: \u0412\u0435\u0441\u044C \u043C\u0438\u0440",
        aboutStatus: "> \u0421\u0442\u0430\u0442\u0443\u0441: \u041E\u0442\u043A\u0440\u044B\u0442 \u043A \u043D\u043E\u0432\u044B\u043C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C",
        aboutSpec: "> \u0421\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F: React, Vue.js, TypeScript, Next.js",
        aboutQuote: '> "\u0421\u043E\u0437\u0434\u0430\u044E \u0430\u0434\u0430\u043F\u0442\u0438\u0432\u043D\u044B\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u044B \u0441 \u0447\u0438\u0441\u0442\u044B\u043C \u0438 \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0438\u0440\u0443\u0435\u043C\u044B\u043C \u043A\u043E\u0434\u043E\u043C"',
        // Experience
        jobLuminary: "Frontend \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A",
        jobLuminaryDesc1: "> \u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 B2B \u0432\u0435\u0431-\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043D\u0430 React \u0438 TypeScript",
        jobLuminaryDesc2: "> \u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430 \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0438 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u043E\u0432",
        jobLuminaryDesc3: "> \u041E\u043F\u0442\u0438\u043C\u0438\u0437\u0430\u0446\u0438\u044F \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0438 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430 \u043A\u043E\u0434\u0430",
        jobLuminaryDesc4: "> \u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0432 \u043A\u0440\u043E\u0441\u0441\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u0435",
        jobEasycode: "Frontend \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A",
        jobEasycodeDesc1: "> \u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0439 HR \u0441\u0438\u0441\u0442\u0435\u043C\u044B",
        jobEasycodeDesc2: "> \u0418\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u0434\u0430\u0448\u0431\u043E\u0440\u0434\u044B \u043D\u0430 Vue.js",
        jobEasycodeDesc3: "> \u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0430\u0434\u0430\u043F\u0442\u0438\u0432\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u043E\u0432 \u043F\u043E \u0434\u0438\u0437\u0430\u0439\u043D\u0443 Figma",
        jobEasycodeDesc4: "> \u041C\u0435\u043D\u0442\u043E\u0440\u0441\u0442\u0432\u043E \u043C\u043B\u0430\u0434\u0448\u0438\u0445 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u0432 \u0438 \u043A\u043E\u0434-\u0440\u0435\u0432\u044C\u044E",
        jobBottec: "Frontend \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A",
        jobBottecDesc1: "> \u0420\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u043B \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u043E\u0439 11 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0441 \u043D\u0443\u043B\u044F",
        jobBottecDesc2: "> \u041B\u0438\u0434\u0435\u0440\u0441\u0442\u0432\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0446\u0438\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432",
        jobBottecDesc3: "> Fullstack \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u0441 \u0441\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u043C\u0438 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u044F\u043C\u0438",
        jobBottecDesc4: "> 100% \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u044B \u0432 \u043F\u0440\u043E\u0434\u0430\u043A\u0448\u043D",
        // Education
        eduMfpu: "\u0412\u044B\u0441\u0448\u0435\u0435 \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435",
        eduMfpuDesc: "> \u0421\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u0432 \u043E\u0431\u043B\u0430\u0441\u0442\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0439 \u0438 \u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0432",
        eduHexlet: "\u041A\u0443\u0440\u0441 Frontend \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438",
        eduHexletDesc1: "> \u0418\u043D\u0442\u0435\u043D\u0441\u0438\u0432\u043D\u0430\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0432\u0435\u0431-\u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438",
        eduHexletDesc2: "> JavaScript, React, \u0441\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0438 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438",
        eduSelf: "\u041D\u0435\u043F\u0440\u0435\u0440\u044B\u0432\u043D\u043E\u0435 \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u0435",
        eduSelfDesc1: "> \u0420\u0430\u0437\u043B\u0438\u0447\u043D\u044B\u0435 \u043E\u043D\u043B\u0430\u0439\u043D-\u043A\u0443\u0440\u0441\u044B \u043F\u043E \u0432\u0435\u0431-\u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435",
        eduSelfDesc2: "> \u041A\u0438\u0431\u0435\u0440\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C \u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u043E\u0435 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
        eduSelfDesc3: "> UX/UI \u0434\u0438\u0437\u0430\u0439\u043D \u0438 \u0441\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435 \u0432\u0435\u0431-\u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0438",
        // Achievements
        achProjects: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432",
        achProduction: "\u041F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0432 \u043F\u0440\u043E\u0434\u0430\u043A\u0448\u043D\u0435",
        achTeam: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
        achExperience: "\u041B\u0435\u0442 \u043E\u043F\u044B\u0442\u0430",
        // Contact
        email: "> \u043F\u043E\u0447\u0442\u0430:",
        telegram: "> \u0442\u0435\u043B\u0435\u0433\u0440\u0430\u043C:",
        github: "> \u0433\u0438\u0442\u0445\u0430\u0431:",
        linkedin: "> \u043B\u0438\u043D\u043A\u0435\u0434\u0438\u043D:",
        phoneRu: "> \u0442\u0435\u043B\u0435\u0444\u043E\u043D_\u0440\u0444:",
        phoneVn: "> \u0442\u0435\u043B\u0435\u0444\u043E\u043D_\u0432\u043D:",
        privacy: '> privacy:',
        privacyText: "\u043F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
        // Commands
        langSwitch: 'lang --switch',
        langSwitchDesc: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u044F\u0437\u044B\u043A \u043C\u0435\u0436\u0434\u0443 \u0430\u043D\u0433\u043B\u0438\u0439\u0441\u043A\u0438\u043C \u0438 \u0440\u0443\u0441\u0441\u043A\u0438\u043C",
        contactDesc: "\u0417\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0443 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430 \u0434\u043B\u044F \u0441\u0432\u044F\u0437\u0438"
    }
};
function $5be814878a8c9e96$var$detectLanguage() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('lang') === 'en') return 'en';
    return 'ru';
}
let $5be814878a8c9e96$export$324a75438e87a537 = $5be814878a8c9e96$var$detectLanguage();
function $5be814878a8c9e96$export$fa43c961ec463ef0() {
    $5be814878a8c9e96$export$324a75438e87a537 = $5be814878a8c9e96$export$324a75438e87a537 === 'en' ? 'ru' : 'en';
    // Update page title
    document.title = $5be814878a8c9e96$export$150b732325d14d04[$5be814878a8c9e96$export$324a75438e87a537].title;
    // Update all translatable elements
    $5be814878a8c9e96$export$676ff478edc2cd7f();
    // Trigger SEO meta updates
    window.dispatchEvent(new CustomEvent('languageChanged', {
        detail: {
            language: $5be814878a8c9e96$export$324a75438e87a537
        }
    }));
    // Update URL without reload
    const url = new URL(window.location);
    if ($5be814878a8c9e96$export$324a75438e87a537 === 'en') url.searchParams.set('lang', 'en');
    else url.searchParams.delete('lang');
    window.history.pushState({}, '', url);
    // Show success message
    const terminalContent = document.querySelector('.terminal-content');
    const successDiv = document.createElement('div');
    successDiv.style.cssText = `
        color: var(--neon-green);
        margin-top: 5px;
        margin-bottom: 10px;
    `;
    successDiv.textContent = `Language switched to ${$5be814878a8c9e96$export$324a75438e87a537 === 'en' ? 'English' : "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"}`;
    // Insert before the current command line
    const currentCommandLine = terminalContent.querySelector('.command-line');
    if (currentCommandLine) terminalContent.insertBefore(successDiv, currentCommandLine);
    else terminalContent.appendChild(successDiv);
}
function $5be814878a8c9e96$export$676ff478edc2cd7f() {
    const t = $5be814878a8c9e96$export$150b732325d14d04[$5be814878a8c9e96$export$324a75438e87a537];
    // Boot sequence
    const bootLines = document.querySelectorAll('.boot-sequence .line');
    bootLines[0].textContent = t.bootLine1;
    bootLines[1].textContent = t.bootLine2;
    bootLines[2].textContent = t.bootLine3;
    bootLines[3].textContent = t.bootLine4;
    bootLines[4].textContent = t.bootLine5;
    // About section
    const aboutContent = document.querySelector('.info-block .content');
    if (aboutContent) {
        const paragraphs = aboutContent.querySelectorAll('p');
        paragraphs[0].textContent = t.aboutAge;
        paragraphs[1].textContent = t.aboutBorn;
        paragraphs[2].textContent = t.aboutLocation;
        paragraphs[3].textContent = t.aboutStatus;
        paragraphs[4].textContent = t.aboutSpec;
        paragraphs[5].textContent = t.aboutQuote;
    }
    // Experience section
    const jobs = document.querySelectorAll('.job');
    // Luminary
    if (jobs[0]) {
        jobs[0].querySelector('.position').textContent = t.jobLuminary;
        const luminaryDesc = jobs[0].querySelectorAll('.job-description p');
        luminaryDesc[0].textContent = t.jobLuminaryDesc1;
        luminaryDesc[1].textContent = t.jobLuminaryDesc2;
        luminaryDesc[2].textContent = t.jobLuminaryDesc3;
        luminaryDesc[3].textContent = t.jobLuminaryDesc4;
    }
    // EasyCode
    if (jobs[1]) {
        jobs[1].querySelector('.position').textContent = t.jobEasycode;
        const easycodeDesc = jobs[1].querySelectorAll('.job-description p');
        easycodeDesc[0].textContent = t.jobEasycodeDesc1;
        easycodeDesc[1].textContent = t.jobEasycodeDesc2;
        easycodeDesc[2].textContent = t.jobEasycodeDesc3;
        easycodeDesc[3].textContent = t.jobEasycodeDesc4;
    }
    // BOTTEC
    if (jobs[2]) {
        jobs[2].querySelector('.position').textContent = t.jobBottec;
        const bottecDesc = jobs[2].querySelectorAll('.job-description p');
        bottecDesc[0].textContent = t.jobBottecDesc1;
        bottecDesc[1].textContent = t.jobBottecDesc2;
        bottecDesc[2].textContent = t.jobBottecDesc3;
        bottecDesc[3].textContent = t.jobBottecDesc4;
    }
    // Education section
    const educationItems = document.querySelectorAll('.education-item');
    if (educationItems[0]) {
        educationItems[0].querySelector('.degree').textContent = t.eduMfpu;
        educationItems[0].querySelector('.edu-description p').textContent = t.eduMfpuDesc;
    }
    if (educationItems[1]) {
        educationItems[1].querySelector('.degree').textContent = t.eduHexlet;
        const hexletDesc = educationItems[1].querySelectorAll('.edu-description p');
        hexletDesc[0].textContent = t.eduHexletDesc1;
        hexletDesc[1].textContent = t.eduHexletDesc2;
    }
    if (educationItems[2]) {
        educationItems[2].querySelector('.degree').textContent = t.eduSelf;
        const selfDesc = educationItems[2].querySelectorAll('.edu-description p');
        selfDesc[0].textContent = t.eduSelfDesc1;
        selfDesc[1].textContent = t.eduSelfDesc2;
        selfDesc[2].textContent = t.eduSelfDesc3;
    }
    // Achievements
    const achievements = document.querySelectorAll('.achievement-item .description');
    achievements[0].textContent = t.achProjects;
    achievements[1].textContent = t.achProduction;
    achievements[2].textContent = t.achTeam;
    achievements[3].textContent = t.achExperience;
    // Contact section
    const contactItems = document.querySelectorAll('.contact-item .label');
    contactItems[0].textContent = t.email;
    contactItems[1].textContent = t.telegram;
    contactItems[2].textContent = t.github;
    contactItems[3].textContent = t.linkedin;
    contactItems[4].textContent = t.phoneRu;
    contactItems[5].textContent = t.phoneVn;
    if (contactItems[6]) contactItems[6].textContent = t.privacy;
}


function $35b6b3c7a0f265f7$export$62d44a696b25a76a() {
    $35b6b3c7a0f265f7$var$createNewCommandLine();
}
function $35b6b3c7a0f265f7$var$createNewCommandLine() {
    const terminalContent = document.querySelector('.terminal-content');
    if (!terminalContent) return;
    // Available commands (description updates with current language)
    const commands = [
        {
            command: 'cmd',
            get description () {
                return (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u043A\u043E\u043C\u0430\u043D\u0434" : 'Show available commands';
            },
            action: ()=>$35b6b3c7a0f265f7$var$showCommandsList(commands)
        },
        {
            command: 'lang --switch',
            get description () {
                return (0, $5be814878a8c9e96$export$150b732325d14d04)[0, $5be814878a8c9e96$export$324a75438e87a537].langSwitchDesc;
            },
            action: ()=>(0, $5be814878a8c9e96$export$fa43c961ec463ef0)()
        },
        {
            command: 'contact',
            get description () {
                return (0, $5be814878a8c9e96$export$150b732325d14d04)[0, $5be814878a8c9e96$export$324a75438e87a537].contactDesc;
            },
            action: ()=>window.contactFormModule.startContactForm()
        }
    ];
    // Create new command line
    const commandLineContainer = document.createElement('div');
    commandLineContainer.className = 'command-line';
    commandLineContainer.style.marginTop = '20px';
    const prompt = document.createElement('div');
    prompt.className = 'prompt';
    prompt.innerHTML = `
        <span class="user" style="color: var(--electric-blue);">nikita@portfolio</span>
        <span class="separator" style="color: var(--white);">:</span>
        <span class="path" style="color: var(--cyber-pink);">~</span>
        <span class="dollar" style="color: var(--neon-green); margin: 0 8px 0 4px;">$</span>
    `;
    // Create input field
    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'command-input';
    input.autocomplete = 'new-password';
    input.autocapitalize = 'off';
    input.autocorrect = 'off';
    input.spellcheck = false;
    input.setAttribute('data-form-type', 'other');
    input.setAttribute('data-lpignore', 'true');
    input.name = 'cmd_' + Math.random().toString(36).substr(2, 9);
    input.setAttribute('readonly', 'readonly');
    setTimeout(()=>input.removeAttribute('readonly'), 100);
    input.placeholder = (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 'cmd' \u0434\u043B\u044F \u0441\u043F\u0438\u0441\u043A\u0430 \u043A\u043E\u043C\u0430\u043D\u0434..." : "Type 'cmd' for commands list...";
    input.style.cssText = `
        background: transparent;
        border: none;
        outline: none;
        color: var(--white);
        font-family: 'Fira Code', monospace;
        font-size: 14px;
        width: 200px;
        caret-color: var(--neon-green);
    `;
    // Create autocomplete dropdown
    const autocomplete = document.createElement('div');
    autocomplete.className = 'autocomplete-dropdown';
    autocomplete.style.cssText = `
        position: absolute;
        top: 100%;
        left: 0;
        background: var(--terminal-bg);
        border: 1px solid var(--neon-green);
        border-radius: 4px;
        max-height: 200px;
        overflow-y: auto;
        z-index: 1000;
        display: none;
        box-shadow: 0 4px 15px rgba(0, 255, 65, 0.3);
    `;
    // Create wrapper for input and autocomplete
    const inputWrapper = document.createElement('span');
    inputWrapper.style.position = 'relative';
    inputWrapper.style.display = 'inline-block';
    inputWrapper.appendChild(input);
    inputWrapper.appendChild(autocomplete);
    prompt.appendChild(inputWrapper);
    commandLineContainer.appendChild(prompt);
    // Remove old command line
    const oldCommandLine = terminalContent.querySelector('.command-line');
    if (oldCommandLine) oldCommandLine.remove();
    terminalContent.appendChild(commandLineContainer);
    // Input event handlers
    input.addEventListener('input', (e)=>{
        const value = e.target.value.toLowerCase();
        $35b6b3c7a0f265f7$var$showAutocomplete(value, commands, autocomplete, input);
    });
    input.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter') {
            const command = e.target.value.trim();
            if (command) $35b6b3c7a0f265f7$var$executeCommand(command, commands);
        } else if (e.key === 'Escape') $35b6b3c7a0f265f7$var$hideAutocomplete(autocomplete);
        else if (e.key === 'Tab') {
            e.preventDefault();
            const activeItem = autocomplete.querySelector('.autocomplete-item.active');
            if (activeItem) {
                e.target.value = activeItem.dataset.command;
                $35b6b3c7a0f265f7$var$hideAutocomplete(autocomplete);
            }
        } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            $35b6b3c7a0f265f7$var$navigateAutocomplete(autocomplete, e.key === 'ArrowDown' ? 1 : -1);
        }
    });
    // Hide autocomplete when clicking outside
    document.addEventListener('click', (e)=>{
        if (!inputWrapper.contains(e.target)) $35b6b3c7a0f265f7$var$hideAutocomplete(autocomplete);
    });
    // Focus input
    input.focus();
    // Scroll to bottom
    terminalContent.scrollTop = terminalContent.scrollHeight;
}
function $35b6b3c7a0f265f7$var$showAutocomplete(value, commands, dropdown, input) {
    const filtered = commands.filter((cmd)=>cmd.command.toLowerCase().includes(value) || cmd.description.toLowerCase().includes(value));
    if (filtered.length === 0 || value === '') {
        $35b6b3c7a0f265f7$var$hideAutocomplete(dropdown);
        return;
    }
    dropdown.innerHTML = '';
    filtered.forEach((cmd, index)=>{
        const item = document.createElement('div');
        item.className = 'autocomplete-item';
        if (index === 0) item.classList.add('active');
        item.dataset.command = cmd.command;
        item.style.cssText = `
            padding: 8px 12px;
            cursor: pointer;
            border-bottom: 1px solid rgba(0, 255, 65, 0.1);
            transition: background-color 0.3s;
        `;
        item.innerHTML = `
            <div style="color: var(--neon-green); font-weight: 600;">${cmd.command}</div>
            <div style="color: var(--white); font-size: 12px; opacity: 0.8;">${cmd.description}</div>
        `;
        item.addEventListener('mouseenter', ()=>{
            dropdown.querySelectorAll('.autocomplete-item').forEach((i)=>i.classList.remove('active'));
            item.classList.add('active');
        });
        item.addEventListener('click', ()=>{
            input.value = cmd.command;
            $35b6b3c7a0f265f7$var$hideAutocomplete(dropdown);
            input.focus();
        });
        dropdown.appendChild(item);
    });
    dropdown.style.display = 'block';
}
function $35b6b3c7a0f265f7$var$hideAutocomplete(dropdown) {
    dropdown.style.display = 'none';
}
function $35b6b3c7a0f265f7$var$navigateAutocomplete(dropdown, direction) {
    const items = dropdown.querySelectorAll('.autocomplete-item');
    const activeIndex = Array.from(items).findIndex((item)=>item.classList.contains('active'));
    if (items.length === 0) return;
    items[activeIndex]?.classList.remove('active');
    let newIndex = activeIndex + direction;
    if (newIndex < 0) newIndex = items.length - 1;
    if (newIndex >= items.length) newIndex = 0;
    items[newIndex].classList.add('active');
}
function $35b6b3c7a0f265f7$var$executeCommand(command, commands) {
    const cmd = commands.find((c)=>c.command.toLowerCase() === command.toLowerCase());
    // Show executed command first
    $35b6b3c7a0f265f7$var$showCommandExecution(command);
    if (cmd) // Execute the command after showing it
    setTimeout(()=>{
        cmd.action();
        // Create new command line after execution (except for contact command)
        if (cmd.command !== 'contact') setTimeout(()=>{
            $35b6b3c7a0f265f7$var$createNewCommandLine();
        }, 300);
    }, 100);
    else if (command.trim() !== '') // Show error and create new command line
    setTimeout(()=>{
        const errorMsg = (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? `\u{41A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{430} '${command}' \u{43D}\u{435} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{430}. \u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} 'cmd' \u{434}\u{43B}\u{44F} \u{441}\u{43F}\u{438}\u{441}\u{43A}\u{430} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}.` : `Command '${command}' not found. Type 'cmd' for commands list.`;
        $35b6b3c7a0f265f7$var$showCommandError(errorMsg);
        $35b6b3c7a0f265f7$var$createNewCommandLine();
    }, 100);
}
function $35b6b3c7a0f265f7$var$showCommandExecution(command) {
    const terminalContent = document.querySelector('.terminal-content');
    const executionDiv = document.createElement('div');
    executionDiv.style.marginTop = '10px';
    const promptLine = document.createElement('div');
    promptLine.innerHTML = `
        <span style="color: var(--electric-blue);">nikita@portfolio</span>
        <span style="color: var(--white);">:</span>
        <span style="color: var(--cyber-pink);">~</span>
        <span style="color: var(--neon-green);">$</span>
        <span style="color: var(--white); margin-left: 8px;">${command}</span>
    `;
    executionDiv.appendChild(promptLine);
    // Insert before the current command line
    const currentCommandLine = terminalContent.querySelector('.command-line');
    if (currentCommandLine) terminalContent.insertBefore(executionDiv, currentCommandLine);
    else terminalContent.appendChild(executionDiv);
}
function $35b6b3c7a0f265f7$var$showCommandError(error) {
    const terminalContent = document.querySelector('.terminal-content');
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = `
        color: var(--cyber-pink);
        margin-top: 5px;
        margin-bottom: 10px;
    `;
    errorDiv.textContent = error;
    // Insert before the current command line
    const currentCommandLine = terminalContent.querySelector('.command-line');
    if (currentCommandLine) terminalContent.insertBefore(errorDiv, currentCommandLine);
    else terminalContent.appendChild(errorDiv);
}
function $35b6b3c7a0f265f7$var$showCommandsList(commands) {
    const terminalContent = document.querySelector('.terminal-content');
    const commandsDiv = document.createElement('div');
    commandsDiv.style.cssText = `
        margin-top: 10px;
        margin-bottom: 15px;
        padding: 15px;
        border: 1px solid var(--neon-green);
        border-radius: 5px;
        background: rgba(0, 20, 20, 0.3);
    `;
    const title = (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u044B:" : 'Available commands:';
    const titleDiv = document.createElement('div');
    titleDiv.style.cssText = `
        color: var(--neon-green);
        font-weight: 600;
        margin-bottom: 10px;
        font-size: 14px;
    `;
    titleDiv.textContent = title;
    commandsDiv.appendChild(titleDiv);
    commands.forEach((cmd)=>{
        const cmdDiv = document.createElement('div');
        cmdDiv.style.cssText = `
            margin: 8px 0;
            padding: 5px 0;
            border-bottom: 1px solid rgba(0, 255, 65, 0.2);
        `;
        cmdDiv.innerHTML = `
            <div style="color: var(--electric-blue); font-weight: 500; margin-bottom: 2px;">${cmd.command}</div>
            <div style="color: var(--white); font-size: 12px; opacity: 0.8; margin-left: 15px;">${cmd.description}</div>
        `;
        commandsDiv.appendChild(cmdDiv);
    });
    // Insert before the current command line
    const currentCommandLine = terminalContent.querySelector('.command-line');
    if (currentCommandLine) terminalContent.insertBefore(commandsDiv, currentCommandLine);
    else terminalContent.appendChild(commandsDiv);
}


var $c68cfc136bcc7828$exports = {};

$parcel$export($c68cfc136bcc7828$exports, "startContactForm", () => $c68cfc136bcc7828$export$d0a20b8110a9810d);

// Contact form functionality
let $c68cfc136bcc7828$var$contactFormData = {};
let $c68cfc136bcc7828$var$contactFormStep = 0;
const $c68cfc136bcc7828$var$contactFormSteps = [
    'name',
    'email',
    'telegram'
];
function $c68cfc136bcc7828$export$d0a20b8110a9810d() {
    $c68cfc136bcc7828$var$contactFormData = {};
    $c68cfc136bcc7828$var$contactFormStep = 0;
    const terminalContent = document.querySelector('.terminal-content');
    // Remove the regular command line that triggered this command
    const regularCommandLine = terminalContent.querySelector('.command-line:not(.contact-form)');
    if (regularCommandLine) regularCommandLine.remove();
    const messageDiv = document.createElement('div');
    messageDiv.style.cssText = `
        color: var(--neon-green);
        margin-top: 5px;
        margin-bottom: 10px;
    `;
    const startMessage = (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? '\u041D\u0430\u0447\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0444\u043E\u0440\u043C\u044B \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430. \u0414\u043B\u044F \u043E\u0442\u043C\u0435\u043D\u044B \u0432\u0432\u0435\u0434\u0438 "cancel" \u0432 \u043B\u044E\u0431\u043E\u0439 \u043C\u043E\u043C\u0435\u043D\u0442.' : 'Starting contact form. Type "cancel" at any time to cancel.';
    messageDiv.textContent = startMessage;
    // Insert before the current command line
    const currentCommandLine = terminalContent.querySelector('.command-line');
    if (currentCommandLine) terminalContent.insertBefore(messageDiv, currentCommandLine);
    else terminalContent.appendChild(messageDiv);
    // Start asking for the first field after a delay
    setTimeout(()=>{
        $c68cfc136bcc7828$var$askNextField();
    }, 500);
}
function $c68cfc136bcc7828$var$askNextField() {
    const terminalContent = document.querySelector('.terminal-content');
    // Remove old contact form command line if exists
    const oldContactForm = terminalContent.querySelector('.command-line.contact-form');
    if (oldContactForm) oldContactForm.remove();
    const currentField = $c68cfc136bcc7828$var$contactFormSteps[$c68cfc136bcc7828$var$contactFormStep];
    let question = '';
    let placeholder = '';
    if ((0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru') switch(currentField){
        case 'name':
            question = "\u0412\u0432\u0435\u0434\u0438 \u0438\u043C\u044F:";
            placeholder = "\u0412\u0430\u0448\u0435 \u0438\u043C\u044F";
            break;
        case 'email':
            question = "\u0412\u0432\u0435\u0434\u0438 email:";
            placeholder = 'example@domain.com';
            break;
        case 'telegram':
            question = "\u0412\u0432\u0435\u0434\u0438 Telegram \u044E\u0437\u0435\u0440\u043D\u0435\u0439\u043C, \u043E\u043F\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E:";
            placeholder = "@username \u0438\u043B\u0438 \u043E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043F\u0443\u0441\u0442\u044B\u043C";
            break;
    }
    else switch(currentField){
        case 'name':
            question = 'Enter name:';
            placeholder = 'Your name';
            break;
        case 'email':
            question = 'Enter email:';
            placeholder = 'example@domain.com';
            break;
        case 'telegram':
            question = 'Enter Telegram username, optional:';
            placeholder = '@username or leave empty';
            break;
    }
    // Create question prompt
    const questionDiv = document.createElement('div');
    questionDiv.style.cssText = `
        color: var(--electric-blue);
        margin-top: 10px;
        margin-bottom: 5px;
    `;
    questionDiv.textContent = question;
    terminalContent.appendChild(questionDiv);
    // Create new command line for input
    const commandLineContainer = document.createElement('div');
    commandLineContainer.className = 'command-line contact-form';
    commandLineContainer.style.marginTop = '5px';
    const prompt = document.createElement('div');
    prompt.className = 'prompt';
    prompt.innerHTML = `
        <span class="user" style="color: var(--electric-blue);">contact</span>
        <span class="separator" style="color: var(--white);">:</span>
        <span class="path" style="color: var(--cyber-pink);">${currentField}</span>
        <span class="dollar" style="color: var(--neon-green); margin: 0 8px 0 4px;">$</span>
    `;
    // Create input field
    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'command-input contact-input';
    input.autocomplete = 'new-password';
    input.autocapitalize = 'off';
    input.autocorrect = 'off';
    input.spellcheck = false;
    input.setAttribute('data-form-type', 'other');
    input.setAttribute('data-lpignore', 'true');
    input.name = 'contact_' + Math.random().toString(36).substr(2, 9);
    input.setAttribute('readonly', 'readonly');
    setTimeout(()=>input.removeAttribute('readonly'), 100);
    input.placeholder = placeholder;
    input.style.cssText = `
        background: transparent;
        border: none;
        outline: none;
        color: var(--white);
        font-family: 'Fira Code', monospace;
        font-size: 14px;
        width: 300px;
        caret-color: var(--neon-green);
    `;
    prompt.appendChild(input);
    commandLineContainer.appendChild(prompt);
    terminalContent.appendChild(commandLineContainer);
    // Handle input
    input.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter') {
            const value = e.target.value.trim();
            // Check for cancel
            if (value.toLowerCase() === 'cancel') {
                $c68cfc136bcc7828$var$cancelContactForm();
                return;
            }
            // Validate required fields
            if (currentField !== 'telegram' && value === '') {
                const errorMsg = (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? "\u042D\u0442\u043E \u043F\u043E\u043B\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F!" : 'This field is required!';
                $c68cfc136bcc7828$var$showFormError(errorMsg);
                return;
            }
            // Validate email
            if (currentField === 'email' && value !== '') {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) {
                    const errorMsg = (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 email \u0430\u0434\u0440\u0435\u0441!" : 'Please enter a valid email address!';
                    $c68cfc136bcc7828$var$showFormError(errorMsg);
                    return;
                }
            }
            // Save the value
            $c68cfc136bcc7828$var$contactFormData[currentField] = value;
            // Show the entered value
            $c68cfc136bcc7828$var$showEnteredValue(currentField, value);
            // Move to next step
            $c68cfc136bcc7828$var$contactFormStep++;
            if ($c68cfc136bcc7828$var$contactFormStep >= $c68cfc136bcc7828$var$contactFormSteps.length) // All data collected, send to Telegram
            $c68cfc136bcc7828$var$sendToTelegram();
            else // Ask for next field
            setTimeout(()=>{
                $c68cfc136bcc7828$var$askNextField();
            }, 500);
        }
    });
    // Focus input
    input.focus();
    // Scroll to bottom
    terminalContent.scrollTop = terminalContent.scrollHeight;
}
function $c68cfc136bcc7828$var$showEnteredValue(field, value) {
    const terminalContent = document.querySelector('.terminal-content');
    const valueDiv = document.createElement('div');
    valueDiv.style.cssText = `
        color: var(--white);
        margin-top: 5px;
        margin-bottom: 10px;
    `;
    const displayValue = value === '' ? (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? "(\u043F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E)" : '(skipped)' : value;
    valueDiv.innerHTML = `
        <span style="color: var(--electric-blue);">contact</span>
        <span style="color: var(--white);">:</span>
        <span style="color: var(--cyber-pink);">${field}</span>
        <span style="color: var(--neon-green);">$</span>
        <span style="color: var(--white); margin-left: 8px;">${displayValue}</span>
    `;
    // Insert before the current command line
    const currentCommandLine = terminalContent.querySelector('.command-line');
    if (currentCommandLine) terminalContent.insertBefore(valueDiv, currentCommandLine);
    else terminalContent.appendChild(valueDiv);
}
function $c68cfc136bcc7828$var$showFormError(errorMsg) {
    const terminalContent = document.querySelector('.terminal-content');
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = `
        color: var(--cyber-pink);
        margin-top: 5px;
        margin-bottom: 10px;
    `;
    errorDiv.textContent = errorMsg;
    // Insert before the current command line
    const currentCommandLine = terminalContent.querySelector('.command-line');
    if (currentCommandLine) terminalContent.insertBefore(errorDiv, currentCommandLine);
    else terminalContent.appendChild(errorDiv);
}
function $c68cfc136bcc7828$var$cancelContactForm() {
    const terminalContent = document.querySelector('.terminal-content');
    // Remove contact form command line
    const contactForm = terminalContent.querySelector('.command-line.contact-form');
    if (contactForm) contactForm.remove();
    // Show cancellation message
    const cancelDiv = document.createElement('div');
    cancelDiv.style.cssText = `
        color: var(--cyber-pink);
        margin-top: 5px;
        margin-bottom: 10px;
    `;
    cancelDiv.textContent = (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? "\u0417\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0444\u043E\u0440\u043C\u044B \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E." : 'Contact form cancelled.';
    terminalContent.appendChild(cancelDiv);
    // Create new regular command line
    setTimeout(()=>{
        window.commandLineModule.initInteractiveCommandLine();
    }, 500);
}
async function $c68cfc136bcc7828$var$sendToTelegram() {
    const terminalContent = document.querySelector('.terminal-content');
    // Remove contact form command line
    const contactForm = terminalContent.querySelector('.command-line.contact-form');
    if (contactForm) contactForm.remove();
    // Show sending message
    const sendingDiv = document.createElement('div');
    sendingDiv.style.cssText = `
        color: var(--electric-blue);
        margin-top: 10px;
        margin-bottom: 10px;
    `;
    sendingDiv.textContent = (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? "\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F..." : 'Sending message...';
    terminalContent.appendChild(sendingDiv);
    // Prepare message for Telegram
    const { name: name, email: email, telegram: telegram } = $c68cfc136bcc7828$var$contactFormData;
    const telegramText = telegram && telegram !== '' ? telegram : "\u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D";
    const message = `\u{1F916} \u{41D}\u{43E}\u{432}\u{43E}\u{435} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435} \u{441} \u{43F}\u{43E}\u{440}\u{442}\u{444}\u{43E}\u{43B}\u{438}\u{43E}!

\u{1F464} \u{418}\u{43C}\u{44F}: ${name}
\u{1F4E7} Email: ${email}
\u{1F4AC} Telegram: ${telegramText}

\u{1F4C5} \u{414}\u{430}\u{442}\u{430}: ${new Date().toLocaleString('ru-RU')}`;
    const botToken = '6021023621:AAE1UuSHsN82EspCiezfTl_5MLnOPuCJjzE';
    const chatId = '5353106736';
    try {
        const response = await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                chat_id: chatId,
                text: message,
                parse_mode: 'HTML'
            })
        });
        const result = await response.json();
        // Remove sending message
        sendingDiv.remove();
        if (result.ok) {
            // Success message
            const successDiv = document.createElement('div');
            successDiv.style.cssText = `
                color: var(--neon-green);
                margin-top: 5px;
                margin-bottom: 10px;
            `;
            successDiv.textContent = (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? "\u2705 \u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E! \u0421\u043A\u043E\u0440\u043E \u044F \u0441\u0432\u044F\u0436\u0443\u0441\u044C \u0441 \u0442\u043E\u0431\u043E\u0439." : "\u2705 Message sent successfully! I will contact you soon.";
            terminalContent.appendChild(successDiv);
        } else throw new Error(result.description || 'Failed to send message');
    } catch (error) {
        console.error('Error sending to Telegram:', error);
        // Remove sending message
        sendingDiv.remove();
        // Error message
        const errorDiv = document.createElement('div');
        errorDiv.style.cssText = `
            color: var(--cyber-pink);
            margin-top: 5px;
            margin-bottom: 10px;
        `;
        errorDiv.textContent = (0, $5be814878a8c9e96$export$324a75438e87a537) === 'ru' ? "\u274C \u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439 \u043F\u043E\u0437\u0436\u0435 \u0438\u043B\u0438 \u0441\u0432\u044F\u0436\u0438\u0441\u044C \u043D\u0430\u043F\u0440\u044F\u043C\u0443\u044E." : "\u274C Error sending message. Please try again later or contact directly.";
        terminalContent.appendChild(errorDiv);
    }
    // Create new command line after a delay
    setTimeout(()=>{
        window.commandLineModule.initInteractiveCommandLine();
    }, 2000);
}


// Matrix Rain Background Effect
function $392918e7483cb9fb$export$68148b2c146efaff() {
    const matrixBg = document.querySelector('.matrix-bg');
    const chars = '01';
    const fontSize = 14;
    const columns = Math.floor(window.innerWidth / fontSize);
    const canvas = document.createElement('canvas');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    canvas.style.position = 'fixed';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.zIndex = '-2';
    canvas.style.opacity = '0.1';
    const ctx = canvas.getContext('2d');
    ctx.font = fontSize + 'px Fira Code';
    ctx.fillStyle = '#00FF41';
    const drops = [];
    for(let i = 0; i < columns; i++)drops[i] = 1;
    function drawMatrix() {
        ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#00FF41';
        for(let i = 0; i < drops.length; i++){
            const text = chars[Math.floor(Math.random() * chars.length)];
            ctx.fillText(text, i * fontSize, drops[i] * fontSize);
            if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) drops[i] = 0;
            drops[i]++;
        }
    }
    matrixBg.appendChild(canvas);
    setInterval(drawMatrix, 100);
    // Resize handler
    window.addEventListener('resize', ()=>{
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
    });
}
function $392918e7483cb9fb$export$c4d8fef79eaf7d91() {
    const glitchElements = document.querySelectorAll('.ascii-art pre');
    glitchElements.forEach((element)=>{
        element.addEventListener('mouseenter', ()=>{
            element.classList.add('glitch');
            element.setAttribute('data-text', element.textContent);
            setTimeout(()=>{
                element.classList.remove('glitch');
            }, 500);
        });
    });
    // Random glitch on terminal title
    const terminalTitle = document.querySelector('.terminal-title');
    if (terminalTitle) setInterval(()=>{
        if (Math.random() > 0.95) {
            terminalTitle.style.textShadow = '2px 0 #ff0080, -2px 0 #00bfff';
            setTimeout(()=>{
                terminalTitle.style.textShadow = 'none';
            }, 100);
        }
    }, 1000);
}
function $392918e7483cb9fb$export$9976c40edcf39dba() {
    const particleContainer = document.createElement('div');
    particleContainer.style.position = 'fixed';
    particleContainer.style.top = '0';
    particleContainer.style.left = '0';
    particleContainer.style.width = '100%';
    particleContainer.style.height = '100%';
    particleContainer.style.pointerEvents = 'none';
    particleContainer.style.zIndex = '-1';
    document.body.appendChild(particleContainer);
    function createParticle() {
        const particle = document.createElement('div');
        particle.style.position = 'absolute';
        particle.style.width = '2px';
        particle.style.height = '2px';
        particle.style.backgroundColor = '#00FF41';
        particle.style.boxShadow = '0 0 10px #00FF41';
        particle.style.borderRadius = '50%';
        particle.style.opacity = Math.random();
        const startX = Math.random() * window.innerWidth;
        const startY = Math.random() * window.innerHeight;
        particle.style.left = startX + 'px';
        particle.style.top = startY + 'px';
        particleContainer.appendChild(particle);
        const duration = 3000 + Math.random() * 2000;
        const endX = startX + (Math.random() - 0.5) * 200;
        const endY = startY + (Math.random() - 0.5) * 200;
        particle.animate([
            {
                left: startX + 'px',
                top: startY + 'px',
                opacity: particle.style.opacity
            },
            {
                left: endX + 'px',
                top: endY + 'px',
                opacity: 0
            }
        ], {
            duration: duration,
            easing: 'ease-out'
        }).onfinish = ()=>{
            particle.remove();
        };
    }
    // Create particles periodically
    setInterval(createParticle, 500);
}
function $392918e7483cb9fb$export$8cbbd54cf40dd51b() {
    const projectCards = document.querySelectorAll('.project-card');
    projectCards.forEach((card)=>{
        card.addEventListener('mouseenter', ()=>{
            // Add scan line effect
            const scanLine = document.createElement('div');
            scanLine.style.position = 'absolute';
            scanLine.style.top = '0';
            scanLine.style.left = '0';
            scanLine.style.width = '100%';
            scanLine.style.height = '2px';
            scanLine.style.background = 'linear-gradient(90deg, transparent, #00FF41, transparent)';
            scanLine.style.animation = 'scan 1s ease-in-out';
            card.appendChild(scanLine);
            setTimeout(()=>scanLine.remove(), 1000);
        });
    });
    // Add scan animation
    const scanStyle = document.createElement('style');
    scanStyle.textContent = `
        @keyframes scan {
            0% { top: 0; opacity: 1; }
            100% { top: 100%; opacity: 0; }
        }
    `;
    document.head.appendChild(scanStyle);
}



// Performance monitoring and Core Web Vitals optimization
// Lazy loading for images
function $322514e4e8da87a6$var$lazyLoadImages() {
    const images = document.querySelectorAll('img[data-src]');
    const imageObserver = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
                img.classList.remove('lazy');
                observer.unobserve(img);
            }
        });
    });
    images.forEach((img)=>imageObserver.observe(img));
}
// Critical CSS optimization
function $322514e4e8da87a6$var$loadNonCriticalCSS() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '../scss/non-critical.scss';
    link.media = 'print';
    link.onload = function() {
        this.media = 'all';
    };
    document.head.appendChild(link);
}
// Preload critical resources
function $322514e4e8da87a6$var$preloadCriticalResources() {
    const criticalResources = [
        {
            href: '../scss/main.scss',
            as: 'style'
        },
        {
            href: '../js/main.js',
            as: 'script'
        },
        {
            href: 'https://fonts.googleapis.com/css2?family=Fira+Code:wght@300;400;500;600;700&display=swap',
            as: 'style'
        }
    ];
    criticalResources.forEach((resource)=>{
        if (!document.querySelector(`link[href="${resource.href}"]`)) {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.href = resource.href;
            link.as = resource.as;
            if (resource.as === 'style') link.onload = function() {
                this.rel = 'stylesheet';
            };
            document.head.appendChild(link);
        }
    });
}
// Core Web Vitals monitoring
function $322514e4e8da87a6$var$initCoreWebVitals() {
    // Monitor LCP (Largest Contentful Paint)
    new PerformanceObserver((entryList)=>{
        for (const entry of entryList.getEntries())if (entry.entryType === 'largest-contentful-paint') console.log('LCP:', entry.startTime);
    }).observe({
        entryTypes: [
            'largest-contentful-paint'
        ]
    });
    // Monitor FID (First Input Delay) - using polyfill approach
    new PerformanceObserver((entryList)=>{
        for (const entry of entryList.getEntries())if (entry.entryType === 'first-input') console.log('FID:', entry.processingStart - entry.startTime);
    }).observe({
        entryTypes: [
            'first-input'
        ]
    });
    // Monitor CLS (Cumulative Layout Shift)
    let clsValue = 0;
    new PerformanceObserver((entryList)=>{
        for (const entry of entryList.getEntries())if (!entry.hadRecentInput) {
            clsValue += entry.value;
            console.log('CLS:', clsValue);
        }
    }).observe({
        entryTypes: [
            'layout-shift'
        ]
    });
}
// Optimize font loading
function $322514e4e8da87a6$var$optimizeFontLoading() {
    // Use font-display: swap for better performance
    const fontLink = document.querySelector('link[href*="fonts.googleapis.com"]');
    if (fontLink && !fontLink.href.includes('display=swap')) fontLink.href += '&display=swap';
}
// Reduce JavaScript execution time
function $322514e4e8da87a6$var$optimizeJavaScriptExecution() {
    // Use requestIdleCallback for non-critical tasks
    if ('requestIdleCallback' in window) requestIdleCallback(()=>{
        // Non-critical initialization tasks
        $322514e4e8da87a6$var$initAnalytics();
        $322514e4e8da87a6$var$setupServiceWorker();
    });
    else // Fallback for browsers without requestIdleCallback
    setTimeout(()=>{
        $322514e4e8da87a6$var$initAnalytics();
        $322514e4e8da87a6$var$setupServiceWorker();
    }, 1000);
}
// Analytics initialization (non-critical)
function $322514e4e8da87a6$var$initAnalytics() {
    // Placeholder for analytics code
    console.log('Analytics initialized');
}
var $93fe0ca3e8a620dd$exports = {};
$93fe0ca3e8a620dd$exports = import.meta.resolve("7yeQP");


// Service Worker setup for caching
function $322514e4e8da87a6$var$setupServiceWorker() {
    if ('serviceWorker' in navigator) navigator.serviceWorker.register($93fe0ca3e8a620dd$exports).then((registration)=>{
        console.log('ServiceWorker registration successful');
    }).catch((error)=>{
        console.log('ServiceWorker registration failed');
    });
}
// Resource hints optimization
function $322514e4e8da87a6$var$addResourceHints() {
    // DNS prefetch for external domains
    const externalDomains = [
        'fonts.googleapis.com',
        'fonts.gstatic.com',
        'unpkg.com'
    ];
    externalDomains.forEach((domain)=>{
        if (!document.querySelector(`link[href="https://${domain}"]`)) {
            const link = document.createElement('link');
            link.rel = 'dns-prefetch';
            link.href = `https://${domain}`;
            document.head.appendChild(link);
        }
    });
}
// Image optimization
function $322514e4e8da87a6$var$optimizeImages() {
    const images = document.querySelectorAll('img');
    images.forEach((img)=>{
        // Add loading="lazy" to images below the fold
        if (!img.hasAttribute('loading')) {
            const rect = img.getBoundingClientRect();
            if (rect.top > window.innerHeight) img.setAttribute('loading', 'lazy');
        }
        // Add proper alt text if missing
        if (!img.hasAttribute('alt')) img.setAttribute('alt', "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u043F\u043E\u0440\u0442\u0444\u043E\u043B\u0438\u043E \u041D\u0438\u043A\u0438\u0442\u044B \u041A\u0430\u0440\u0430\u0441\u0451\u0432\u0430");
        // Add width and height to prevent layout shifts
        if (!img.hasAttribute('width') || !img.hasAttribute('height')) img.addEventListener('load', function() {
            if (!this.hasAttribute('width')) this.setAttribute('width', this.naturalWidth);
            if (!this.hasAttribute('height')) this.setAttribute('height', this.naturalHeight);
        });
    });
}
// Initialize all performance optimizations
function $322514e4e8da87a6$export$b10bffb7835f0355() {
    // Run critical optimizations immediately
    $322514e4e8da87a6$var$optimizeFontLoading();
    $322514e4e8da87a6$var$addResourceHints();
    $322514e4e8da87a6$var$preloadCriticalResources();
    // Run when DOM is ready
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>{
        $322514e4e8da87a6$var$lazyLoadImages();
        $322514e4e8da87a6$var$optimizeImages();
        $322514e4e8da87a6$var$initCoreWebVitals();
    });
    else {
        $322514e4e8da87a6$var$lazyLoadImages();
        $322514e4e8da87a6$var$optimizeImages();
        $322514e4e8da87a6$var$initCoreWebVitals();
    }
    // Run non-critical optimizations after page load
    window.addEventListener('load', ()=>{
        $322514e4e8da87a6$var$optimizeJavaScriptExecution();
        $322514e4e8da87a6$var$loadNonCriticalCSS();
    });
}
// Auto-initialize
$322514e4e8da87a6$export$b10bffb7835f0355();


// Make modules available globally for cross-module communication
window.translationsModule = $5be814878a8c9e96$exports;
window.commandLineModule = $35b6b3c7a0f265f7$exports;
window.contactFormModule = $c68cfc136bcc7828$exports;
document.addEventListener('DOMContentLoaded', function() {
    // Initialize performance optimizations first
    (0, $322514e4e8da87a6$export$b10bffb7835f0355)();
    // Set initial language and page title
    document.title = $5be814878a8c9e96$exports.translations[$5be814878a8c9e96$exports.currentLanguage].title;
    // Initialize translations system
    $5be814878a8c9e96$exports.updateTranslations();
    // Matrix Rain Effect
    (0, $392918e7483cb9fb$export$68148b2c146efaff)();
    // Initialize sequential section animations
    (0, $3f763f07b7f268f2$export$949d06beb7be649c)();
    // Add glitch effects
    (0, $392918e7483cb9fb$export$c4d8fef79eaf7d91)();
    // Initialize particle system
    (0, $392918e7483cb9fb$export$9976c40edcf39dba)();
    // Initialize cursor blink
    (0, $3f763f07b7f268f2$export$e01dc2784d396ab2)();
    // Initialize project card effects
    (0, $392918e7483cb9fb$export$8cbbd54cf40dd51b)();
    // Initialize Feather icons
    feather.replace();
});


//# sourceMappingURL=pug.adc29ba4.js.map
